import { ProgramService } from "@adfenix/types";

export function getNotificationWithType<
  T extends
    | ProgramService.ProgramTicketModel
    | ProgramService.ProgramEmailModel,
  U extends "email" | "ticket"
>(type: U, notifications: T[]): (T & { type: U })[] {
  return (
    notifications?.map(x => ({
      type,
      ...x
    })) ?? []
  );
}

export function groupAndSortNotifications(
  emails: ProgramService.ProgramEmailModel[],
  tickets: ProgramService.ProgramTicketModel[]
) {
  const emailsWithType = getNotificationWithType("email", emails);
  const ticketsWithType = getNotificationWithType("ticket", tickets);

  return [...emailsWithType, ...ticketsWithType].sort((x, y) => {
    const xOrDefault = x?.id ?? "0";
    const yOrDefault = y?.id ?? "0";
    if (xOrDefault < yOrDefault) {
      return -1;
    }

    if (xOrDefault > yOrDefault) {
      return 1;
    }

    return 0;
  });
}
